import { Component, OnInit } from '@angular/core';
import { RefreshPreferencesServices } from 'src/app/services/RefreshPreferences.service';

@Component({
    selector: 'system',
    templateUrl: './system.component.html',
    styleUrls: ['./system.component.scss'],
    standalone: false
})
export class SystemComponent implements OnInit {

  constructor(private prefServices:RefreshPreferencesServices) { }

  ngOnInit(): void {
  }

  reloadPreferencia(){
      this.prefServices.refresh(null);
  }


  descartarCache(){
      this.prefServices.clearCache(null);
  }
}
